<template>
    <div class="map-page-container">
        <el-amap :center="center" :zoom="zoom" @click="clickMap">
            <!-- <el-amap-search-box @select="selectPoi" @choose="choosePoi"  /> -->
            <el-amap-search-box :visible="true" @select="selectPoi" ref="poi" @choose="choosePoi"></el-amap-search-box>
            <span @click="search()" style="    position: absolute; top: 20px; left: 390px; cursor: pointer;">搜索</span>
            <!-- <input type="text" id="input" class="searchInp" v-model="text" @select="selectPoi" @choose="choosePoi" /> -->
            <!-- :inputCustom="true"  inputId="input"-->
            <el-amap-marker
                :position="componentMarker.position"
                :visible="componentMarker.visible"
                :draggable="componentMarker.draggable"
                @init="markerInit"
                @click="clickMarker"
            >
            </el-amap-marker>
        </el-amap>
    </div>
</template>

<style></style>

<script>
import { defineComponent } from "vue";
import api from "@/request/api";

export default defineComponent({
    props: ["data", "dzData"],
    name: "Map",
    data() {
        return {
            zoom: 12,
            center: [121.59996, 31.197646],
            componentMarker: {
                position: [121.5273285, 31.21315058],
                visible: true,
                draggable: false
            },
            text: ""
        };
    },
    mounted() {},
    methods: {
        centerFun() {
            var that = this;
            if (this.dzData != null || this.dzData != "" || this.dzData != undefined) {
                AMap.plugin("AMap.Geocoder", function() {
                    var geocoder = new AMap.Geocoder({
                        city: ""
                    });
                    geocoder.getLocation(that.dzData, function(status, result) {
                        if (status === "complete" && result.geocodes.length) {
                            var lnglat = result.geocodes[0].location;
                            that.center = [lnglat.lng, lnglat.lat];
                            that.markers = [[lnglat.lng, lnglat.lat]];
                            that.componentMarker.position = [lnglat.lng, lnglat.lat];
                        } else {
                            console.log("根据地址查询位置失败");
                        }
                    });
                });
            } else {
                api.familyGet(sessionStorage.getItem("fid")).then((res) => {
                    if (res.data.coordinate == "") {
                        this.center = [116.367827, 40.0865];
                        this.markers = [[116.396889, 39.908667]];
                    } else {
                        this.center = res.data.coordinate.split(", ");
                        this.markers = [res.data.coordinate.split(", ")];
                        this.componentMarker.position = [Number(res.data.coordinate.split(", ")[0]), Number(res.data.coordinate.split(", ")[1])];
                    }
                });
            }
        },
        clickMap(e) {
            var _this = this;
            AMap.plugin("AMap.Geocoder", function() {
                var geocoder = new AMap.Geocoder({
                    radius: 1000,
                    extensions: "all"
                });
                geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], function(status, result) {
                    if (status === "complete" && result.info === "OK") {
                        if (result && result.regeocode) {
                            _this.$emit("getLnglat", e.lnglat.lng, e.lnglat.lat, result.regeocode.formattedAddress);
                        }
                    }
                });
            });
        },

        selectPoi(e) {
            this.center = [e.poi.location.lng, e.poi.location.lat];
            this.componentMarker.position = [e.poi.location.lng, e.poi.location.lat];
        },
        choosePoi(e) {
            this.center = [e.poi.location.lng, e.poi.location.lat];
            this.componentMarker.position = [e.poi.location.lng, e.poi.location.lat];
        },
        search() {
            var that = this;
            AMap.plugin("AMap.Geocoder", function() {
                var geocoder = new AMap.Geocoder({
                    city: ""
                });
                geocoder.getLocation(that.$refs.poi.$amapComponent.lastKeywords, function(status, result) {
                    if (status === "complete" && result.geocodes.length) {
                        var lnglat = result.geocodes[0].location;
                        that.center = [lnglat.lng, lnglat.lat];
                        that.markers = [[lnglat.lng, lnglat.lat]];
                        that.componentMarker.position = [lnglat.lng, lnglat.lat];
                    } else {
                        console.log("根据地址查询位置失败");
                    }
                });
            });
        },
        markerInit(e) {
            console.log("marker init: ", e);
        },
        clickMarker(e) {
            // console.log(e);
            this.clickMap(e);
        }
    },
    watch: {
        data: {
            handler(newVal, newOld) {
                if (newVal == null || newVal == "" || newVal == undefined) {
                    this.centerFun();
                } else {
                    this.center = this.data.split(",");
                    this.markers = [this.data.split(",")];
                    this.componentMarker.position = [Number(this.data.split(",")[0]), Number(this.data.split(",")[1])];
                }
            },
            immediate: true,
            deep: true
        }
    }
});
</script>

<style scoped lang="less">
.map-page-container {
    width: 100%;
    height: 100%;
    .search-box {
        position: absolute;
        top: 25px;
        left: 20px;
    }
    .amap-wrapper {
        width: 100%;
        height: 100%;
        position: relative;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/vmap.vue